<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/absen-list">Daftar Absensi</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Input Absensi
        </li>
        <li class="breadcrumb-item">
          <a href="#/absen-bulan-import">Import Absensi</a>
        </li>
      </ol>
    </nav>
    <h5 class="content-block">Input Absensi</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Peraturan Absensi</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxSelectBox
                :dataSource="bulanSource"
                valueExpr="id"
                displayExpr="name"
                width="100%"
                label="Periode Bulan"
                placeholder="Periode Bulan"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.bulan"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="tahunSource"
                width="100%"
                label="Periode Tahun"
                placeholder="Periode Tahun"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.tahun"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>

            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="validateFilter"
                text="Buat Daftar Absen"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxPopup
          :visible="popupLoadingVisible"
          title="Loading..."
          :drag-enabled="false"
          :hide-on-outside-click="false"
          width="300"
          :height="130"
        >
          <div class="d-flex justify-content-center">
            <div
              class="spinner-border"
              style="width: 3rem; height: 3rem"
              role="status"
            ></div>
          </div>
        </DxPopup>

        <DxDataGrid
          class="focused-grid"
          :selection="{ mode: 'single' }"
          ref="dataGrid"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="id"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @editing-start="editingStart"
          @row-updating="onRowUpdating($event, 'dataGrid')"
          @exporting="onExporting"
          :filter-sync-enabled="true"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
        >
          <DxEditing
            :allow-updating="can('absensi-update')"
            :allow-deleting="false"
            :allow-adding="false"
            mode="row"
          />

          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />

          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>

          <DxColumnFixing :enabled="true" />

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            data-type="number"
            caption=" "
            :allow-exporting="false"
            :allow-edititng="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
          <!-- <DxColumn caption="id" data-field="id" /> -->
          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />

          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
          <DxColumn
            data-type="string"
            data-field="simpeg_pegawais_nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-field="simpeg_pegawais_nama"
            caption="Nama"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-field="periode_absen"
            caption="Periode Absen"
            data-type="date"
            :display-format="'MM/yyyy'"
            :format="'MM/yyyy'"
            :filter-operations="filterOperations"
            :fixed="true"
            fixed-position="left"
            cell-template="periodeAbsenTemplate"
            :allowHeaderFiltering="false"
            :allow-filtering="false"
            :allow-sorting="false"
          >
          </DxColumn>
          <template #periodeAbsenTemplate="{ data }">
            {{ formatMonth(data.text) }}
          </template>

          <DxColumn
            dataField="pegawai_statuses_nama"
            caption="Status Pegawai"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.pegawaiStatusSource }"
          >
          </DxColumn>
          <DxColumn
            data-field="jabatans_nama"
            caption="Jabatan"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.jabatanSource }"
          />

          <DxColumn
            dataField="cabangs_nama"
            caption="Cabang"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.cabangSource }"
          >
          </DxColumn>

          <DxColumn
            dataField="units_nama"
            caption="Unit"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.unitSource }"
          >
          </DxColumn>

          <DxColumn
            dataField="bagians_nama"
            caption="Bagian"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.bagianSource }"
          >
          </DxColumn>

          <DxColumn
            dataField="sub_bagians_nama"
            caption="Sub Bagian"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.subBagianSource }"
          >
          </DxColumn>
          <DxColumn
            dataField="bidangs_nama"
            caption="Bidang"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.bidangSource }"
          >
          </DxColumn>
          <DxColumn
            dataField="sub_bidangs_nama"
            caption="Sub Bidang"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.subBidangSource }"
          >
          </DxColumn>
          <DxColumn
            dataField="seksis_nama"
            caption="Seksi"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.seksiSource }"
          >
          </DxColumn>

          <DxColumn
            data-field="hadir"
            caption="Hadir"
            data-type="number"
            :allowHeaderFiltering="false"
          ></DxColumn>

          <DxColumn
            data-field="sakit"
            data-type="number"
            caption="Sakit"
            :set-cell-value="setCellValueSakit"
            :allowHeaderFiltering="false"
          ></DxColumn>
          <DxColumn
            data-field="ijin"
            data-type="number"
            caption="Ijin"
            :set-cell-value="setCellValueIjin"
            :allowHeaderFiltering="false"
          ></DxColumn>
          <DxColumn
            data-field="alpa"
            data-type="number"
            caption="Alpa"
            :set-cell-value="setCellValueAlpa"
            :allowHeaderFiltering="false"
          ></DxColumn>
          <DxColumn
            data-field="cuti"
            data-type="number"
            caption="Cuti"
            :set-cell-value="setCellValueCuti"
            :allowHeaderFiltering="false"
          ></DxColumn>
          <DxColumn
            data-field="libur"
            data-type="number"
            caption="Libur/Cuti Bersama"
            :set-cell-value="setCellValueLibur"
            :allowHeaderFiltering="false"
          ></DxColumn>
          <DxColumn
            data-field="tidak_hadir"
            data-type="number"
            caption="Tdk Hadir"
            css-class="cell-highlighted"
            :allowHeaderFiltering="false"
          ></DxColumn>

          <DxSummary>
            <DxTotalItem
              column="id"
              summary-type="count"
              value-format="#,##0"
            />
            <DxTotalItem
              column="hadir"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="sakit"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="ijin"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="alpa"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="cuti"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="libur"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="tidak_hadir"
              summary-type="sum"
              value-format="#,##0"
            />
          </DxSummary>
        </DxDataGrid>
      </div>
      <!-- current
      <li>input april absen based on data excel OK</li>
      <li>generate gaji using this absen</li>
      <li>compare gaji ori with generated gaji from system</li>

      next
      <li>
        menu daftar absen hanya bisa diedit untuk bulan sekarang dan jika gaji
        belum keluar
      </li>
      <li>menu generate gaji, check if absen exist for pegawai</li>
      <li>pas generate gaji, jml_tdk_hadir ambil dari table absen</li>
      <li>add download template for importing absen data</li>
      <li>add import menu for absen</li> -->
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import { useCommonStore } from "@/stores/utility/common-store";
import { DxPopup } from "devextreme-vue/popup";
import { useAbsenStore } from "@/stores/views/absen-store";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import can from "@/haspermission";
import auth from "@/auth";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import axios from "axios";
import notify from "devextreme/ui/notify";
import DxButton from "devextreme-vue/button";
import { DateTime } from "luxon";
import DxSelectBox from "devextreme-vue/select-box";

// import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  // DxSelection,
  DxToolbar,
  DxExport,
  // DxItem,
  // DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxScrolling,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { useBagianStore } from "@/stores/BagianStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";
import { usePegawaiStatusStore } from "@/stores/PegawaiStatusStore";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
// import { toHandlerKey } from "vue";

//GAGAL
// DateTime.local().setLocale("id");
// console.log(DateTime.local().months);
// const months = DateTime.local().months;
// console.log(months);
const months = [
  { name: "Januari", id: 1 },
  { name: "Februari", id: 2 },
  { name: "Maret", id: 3 },
  { name: "April", id: 4 },
  { name: "Mei", id: 5 },
  { name: "Juni", id: 6 },
  { name: "Juli", id: 7 },
  { name: "Agustus", id: 8 },
  { name: "September", id: 9 },
  { name: "Oktober", id: 10 },
  { name: "November", id: 11 },
  { name: "Desember", id: 12 },
];

const currentYear = DateTime.now().toFormat("yyyy");
const currentMonth = DateTime.now().toFormat("M");
const years = [
  Number(currentYear) - 1,
  currentYear,
  Number(currentYear) + 1,
  Number(currentYear) + 2,
  Number(currentYear) + 3,
];
const options = ["Detail Pegawai", "Absensi", "Riwayat Gaji"];
// console.log(currentMonth);

export default {
  components: {
    DxButton,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,

    DxToolbar,
    // DxItem,
    // DxButtonDatagrid,
    // DxDropDownButton,
    DxSelectBox,
    DxExport,
    DxDropDownButton,
    DxSummary,
    DxTotalItem,
    DxPopup,
    DxScrolling,
    DxHeaderFilter,
  },
  setup() {
    const absenStore = useAbsenStore();
    const cabangStore = useCabangStore();
    const unitStore = useUnitStore();
    const bagianStore = useBagianStore();
    const bidangStore = useBidangStore();
    const subBagianStore = useSubBagianStore();
    const subBidangStore = useSubBidangStore();
    const seksiStore = useSeksiStore();
    const pegawaiStatusStore = usePegawaiStatusStore();
    const commonStore = useCommonStore();
    return {
      pegawaiStatusStore,
      cabangStore,
      unitStore,
      bagianStore,
      bidangStore,
      subBagianStore,
      subBidangStore,
      seksiStore,
      absenStore,
      commonStore,
    };
  },
  data() {
    return {
      options: options,
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      bulan: currentMonth,
      tahun: currentYear,
      // selectTextOnEditStart: true,
      // startEditAction: "click",
      pegawaiStatusSource: null,
      cabangSource: null,
      unitSource: null,
      bagianSource: null,
      bidangSource: null,
      subBagianSource: null,
      subBidangSource: null,
      seksiSource: null,
      numberingPageSize: 100,
      numberingPageNumber: 0,
      // dataSource: [
      //   {
      //     ID: 0,
      //     pegawai_id: "",
      //   },
      // ],
      dataSource: null,
      filters: {
        bulan: Number(currentMonth),
        tahun: currentYear,
      },
      bulanSource: months,
      tahunSource: years,
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",

      skemaGajiSource: null,
      popupLoadingVisible: false,
    };
  },
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "70vh"; // Set the height to fill the viewport vertically
    },
  },
  async mounted() {
    this.pegawaiStatusSource = await this.pegawaiStatusStore.get();
    this.cabangSource = await this.cabangStore.get();
    this.unitSource = await this.unitStore.get();
    this.bagianSource = await this.bagianStore.get();
    this.bidangSource = await this.bidangStore.get();
    this.subBagianSource = await this.subBagianStore.get();
    this.subBidangSource = await this.subBidangStore.get();
    this.seksiSource = await this.seksiStore.get();
  },

  methods: {
    onItemClick(e) {
      let pegawaiId = e.element.id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "simpeg-pegawai-detail",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Absen Pegawai.xlsx"
          );
        });
      });
      e.cancel = true;
    },
    can,
    formatMonth(e) {
      const isoDateString = e.split("/").reverse().join("-") + "-01";
      const date = DateTime.fromISO(isoDateString).setLocale("id");
      return date.monthLong + " " + date.year;
    },
    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    detailPegawai(e) {
      const url = this.$router.resolve({
        name: "simpeg-pegawai-detail",
        query: { id: e.row.data.pegawai_id },
      }).href;
      window.open(url, "_blank");

      // this.$router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: e.row.data.pegawai_id },
      // });
    },

    onRowUpdating(e) {
      // Prevent the default updating behavior until the async operation is complete
      const event = e;
      const updatedData = { ...e.oldData, ...e.newData };
      e.cancel = new Promise((resolve) => {
        (async () => {
          try {
            // Make the Axios call

            const config = {
              headers: {
                Authorization: api.defaults.headers.common["Authorization"],
                "content-type": "application/json",
              },
            };
            var data = {
              pegawai_id: event.oldData.pegawai_id,
              tgl_gaji: event.oldData.periode_absen,
            };
            const response = await axios.post(
              `${API_BASE_URL}/gaji_approve_get`,
              data,
              config
            );

            // Check the response and decide whether to cancel the update
            if (response.data.data) {
              event.component.cancelEditData();

              notify(
                "Gaji pegawai sudah disetujui, tidak dapat mengubah kehadiran.",
                "error"
              );
              resolve(true); // Cancel the update
            } else {
              if (response.data.tidak_hadir !== updatedData.tidak_hadir) {
                await this.saveEditedDataToOData(
                  event.key,
                  event.newData,
                  event.oldData
                );
              }

              resolve(false); // Allow the update
            }
          } catch (error) {
            console.error("Axios call failed:", error);
            event.component.cancelEditData();
            notify("Gagal mengubah kehadiran.", "error");
            resolve(true); // Cancel the update on error
          }
        })();
      });
    },
    // async onRowUpdating2(e, ref) {
    //   if (e.newData.tidak_hadir !== e.oldData.tidak_hadir) {
    //     const response = await this.getGajiApproved(
    //       e.key,
    //       e.newData,
    //       e.oldData
    //     );
    //     if (response.data === false)
    //       await this.saveEditedDataToOData(e.key, e.newData, e.oldData);
    //     else {
    //       e.cancel = true;
    //       e.component.cancelEditData();
    //       notify("Gagal update data gaji karena sudah approved!", "error");
    //     }
    //   }
    // },

    // async getGajiApproved(key, newData, oldData) {
    //   const config = {
    //     headers: {
    //       Authorization: api.defaults.headers.common["Authorization"],
    //       "content-type": "application/json",
    //     },
    //   };
    //   var data = {
    //     pegawai_id: oldData.pegawai_id,
    //     tgl_gaji: oldData.periode_absen,
    //   };
    //   const response = await axios.post(
    //     `${API_BASE_URL}/gaji_approve_get`,
    //     data,
    //     config
    //   );
    //   return response.data.data;
    // },
    async saveEditedDataToOData(key, newData, oldData) {
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        var data = {
          id: null,
          pegawai_id: oldData.pegawai_id,
          tgl_gaji: oldData.periode_absen,
          absen_bulan_id: oldData.id,
          changes: null,
          proyeksi: false,
          jml_tdk_masuk: newData.tidak_hadir,
          edited_by_user_id: auth.getUser().id,
        };
        const response = await axios.post(
          `${API_BASE_URL}/refresh_gaji_per_pegawai`,
          data,
          config
        );
        // You can access the response data using response.data
        if (response.data.status) {
          notify(response.data.message, "success");
          return response.data;
        } else {
          notify("Gagal update absen/gaji pegawai", "error");
          return response.data;
        }
        // You can perform other operations here based on the response data
        // ...
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update absen/gaji pegawai " + error, "error");
        return false; // If there was an error
      }
    },
    async saveEditedDataToODataLAMA(key, newData, oldData) {
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        var data = {
          id: null,
          pegawai_id: oldData.pegawai_id,
          tgl_gaji: oldData.tgl_gaji,
          absen_bulan_id: oldData.id,
          changes: null,
          jml_tdk_masuk: newData.tidak_hadir,
        };
        const response = await axios.post(
          `${API_BASE_URL}/refresh_gaji_per_pegawai`,
          data,
          config
        );
        // You can access the response data using response.data
        if (response.data.status) {
          notify(response.data.message, "success");
          return response.data;
        } else {
          notify("Gagal update absen/gaji pegawai", "error");
          return response.data;
        }
        // You can perform other operations here based on the response data
        // ...
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update absen/gaji pegawai " + error, "error");
        return false; // If there was an error
      }
    },
    // formatStatusGaji(method, val) {
    //   if (
    //     typeof val === "undefined" ||
    //     val.data.value === null ||
    //     !val.data.value
    //   ) {
    //     if (method == "icon") return "edit";
    //     if (method == "type") return "danger";
    //   }
    //   if (val.data.value) {
    //     if (method == "icon") return "lock";
    //     if (method == "type") return "success";
    //   }

    //   return;
    // },
    setCellValueCuti(newData, value) {
      newData.cuti = value;
    },

    setCellValueAlpa(newData, value, currentRowData) {
      newData.alpa = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.ijin) +
        this.nullOrZero(currentRowData.sakit) +
        this.nullOrZero(currentRowData.libur);
    },
    setCellValueIjin(newData, value, currentRowData) {
      newData.ijin = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.sakit) +
        this.nullOrZero(currentRowData.alpa) +
        this.nullOrZero(currentRowData.libur);
    },
    setCellValueLibur(newData, value, currentRowData) {
      newData.libur = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.sakit) +
        this.nullOrZero(currentRowData.alpa) +
        this.nullOrZero(currentRowData.ijin);
    },
    setCellValueSakit(newData, value, currentRowData) {
      newData.sakit = value;
      newData.tidak_hadir =
        this.nullOrZero(value) +
        this.nullOrZero(currentRowData.ijin) +
        this.nullOrZero(currentRowData.alpa) +
        this.nullOrZero(currentRowData.libur);
    },
    nullOrZero(num) {
      if (num === null) return 0;
      return parseInt(num);
    },
    // keyDown(e) {
    //   console.log("keyDown", e);
    //   // console.log(e.component.getRowElement(e.event.currentTarget));
    // },

    // handleCellChanging(e) {
    //   console.log("handleCellChanging", e);
    //   const numHadir = this.nullOrZero(
    //     e.component.cellValue(e.newRowIndex, "hadir")
    //   );

    //   const numIjin = this.nullOrZero(
    //     e.component.cellValue(e.newRowIndex, "ijin")
    //   );
    //   const numSakit = this.nullOrZero(
    //     e.component.cellValue(e.newRowIndex, "sakit")
    //   );
    //   const numAlpa = this.nullOrZero(
    //     e.component.cellValue(e.newRowIndex, "alpa")
    //   );
    //   const numCuti = this.nullOrZero(
    //     e.component.cellValue(e.newRowIndex, "cuti")
    //   );
    // },
    // handleCellChanged(e) {
    //   console.log("handleCellChanged", e);
    //   const numHadir = this.nullOrZero(
    //     e.component.cellValue(e.rowIndex, "hadir")
    //   );

    //   const numIjin = this.nullOrZero(
    //     e.component.cellValue(e.rowIndex, "ijin")
    //   );
    //   const numSakit = this.nullOrZero(
    //     e.component.cellValue(e.rowIndex, "sakit")
    //   );
    //   const numAlpa = this.nullOrZero(
    //     e.component.cellValue(e.rowIndex, "alpa")
    //   );
    //   const numCuti = this.nullOrZero(
    //     e.component.cellValue(e.rowIndex, "cuti")
    //   );
    // },
    editingStart(e) {
      // const element = e.component.getCellElement(
      //   e.component.getRowIndexByKey(e.key),
      //   "hadir"
      // );
      // e.component.focus(element);

      if (
        e.column.dataField === "hadir" ||
        e.column.dataField === "sakit" ||
        e.column.dataField === "ijin" ||
        e.column.dataField === "alpa" ||
        e.column.dataField === "cuti" ||
        e.column.dataField === "libur"
      ) {
        e.cancel = false;
      } else {
        e.cancel = true;
      }
    },
    oneditorpreparing(e) {
      // if (e.parentType !== "filterRow") e.editorOptions.disabled = true;
      //klo pake ini malahan semuanya disable termasuk selection
      if (
        e.parentType === "dataRow" &&
        (e.dataField === "hadir" ||
          e.dataField === "sakit" ||
          e.dataField === "ijin" ||
          e.dataField === "alpa" ||
          e.dataField === "cuti" ||
          e.dataField === "libur")
      ) {
        e.editorOptions.disabled = false;
      } else if (e.parentType === "dataRow") {
        e.editorOptions.disabled = true;
      }

      // if (
      //   e.parentType === "dataRow" &&
      //   (e.dataField === "pegawai.nama" ||
      //     e.dataField === "pegawai_id" ||
      //     e.dataField === "riwayatPekerjaan.cabang_id" ||
      //     e.dataField === "riwayatPekerjaan.bagian_id" ||
      //     e.dataField === "riwayatPekerjaan.sub_bagian_id" ||
      //     e.dataField === "riwayatPekerjaan.seksi_id")
      // ) {
      //   console.log("adalah datarow");
      //   console.log(e.dataField);
      //   e.editorOptions.disabled = true;
      // }

      return;
      // if (!e.row.isNewRow) e.editorOptions.disabled = true;
      // e.parentType === "dataRow" &&
      // e.dataField !== "pegawai_id" &&
      // e.dataField !== "riwayatPekerjaan.cabang_id" &&
      // e.dataField !== "riwayatPekerjaan.bagian_id" &&
      // e.dataField !== "riwayatPekerjaan.sub_bagian_id" &&
      // e.dataField !== "riwayatPekerjaan.seksi_id"
    },

    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    async validateFilter() {
      let periodeAbsen = this.filters.tahun + "-" + this.filters.bulan + "-01";
      let dataSource = this.absenStore.dataSourceAbsen([
        "periode_absen",
        "=",
        periodeAbsen,
      ]);
      let result = await dataSource.load();
      if (result.length > 0) {
        // alert("INPUT ABSEN PADA PERIODE INI SUDAH DILAKSANAKAN");
        notify("INPUT ABSEN PADA PERIODE INI SUDAH DILAKSANAKAN", "error");
      } else {
        //generate gaji!!
        this.generateAbsen();
      }

      //tambahkan limit, tidak boleh generate gaji yang sudah digenerate!
    },

    async generateAbsen() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      var data = {
        bulan: this.filters.bulan,
        tahun: this.filters.tahun,
      };

      this.popupLoadingVisible = true;
      await axios
        .post(`${API_BASE_URL}/absen_bulan_input`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
          this.getAbsen();
          this.popupLoadingVisible = false;
        })
        .catch((error) => {
          console.log(error);
          notify("Gagal Generate Absen", "error");
          this.popupLoadingVisible = false;
        });
    },

    async getAbsen() {
      let periodeAbsen = this.filters.tahun + "-" + this.filters.bulan + "-01";
      this.dataSource = this.absenStore.dataSourceAbsen([
        ["periode_absen", "=", periodeAbsen],
        "and",
        ["simpeg_pegawais.status_aktif_id", "=", "1"],
      ]);
    },
  },
};
</script>
